module.exports = __webpack_public_path__ + "img/ios1icon5.38ecd421.png";